import React, { useState, useEffect } from 'react';

const Avatar = ({ userId, userName, avatarUrl, size = 'md', className = '' }) => {
  const [imgSrc, setImgSrc] = useState(avatarUrl);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  // Update imgSrc when avatarUrl prop changes
  useEffect(() => {
    console.log(`Avatar component for ${userName}: avatarUrl=${avatarUrl ? 'EXISTS' : 'NULL'}`);
    setImgSrc(avatarUrl);
    setImageLoaded(false);
  }, [avatarUrl, userName]);
  
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-xl'
  };

  // If no avatar URL, show empty placeholder
  if (!imgSrc) {
    return (
      <div className={`${sizes[size]} ${className} rounded-full bg-gray-400 border-2 border-white dark:border-gray-700`}></div>
    );
  }

  // Always render the image - let browser handle loading
  return (
    <img
      key={imgSrc}
      src={imgSrc}
      alt={userName || 'User'}
      className={`${sizes[size]} ${className} rounded-full object-cover border-2 border-white dark:border-gray-700`}
      loading="eager"
      crossOrigin="anonymous"
      onLoad={() => setImageLoaded(true)}
      onError={(e) => {
        console.warn(`Failed to load avatar for ${userName}: ${imgSrc}`);
        // Keep showing the img tag even on error - browser will show broken image icon or retry
      }}
    />
  );
};

export default Avatar;
